// extracted by mini-css-extract-plugin
export default {"searchForm":"bv_gL"};